import { backlog_table_headers } from "../../Pages/HomePage/components/BacklogTable/backlog_format";
import { render_status_cell } from "../../Pages/HomePage/components/BacklogTable/utils/backlog_datagrid_cell_renderer";
import { convert_date_to_dd_mm_yyyy, convert_dd_mm_yy_to_milliseconds } from "../../Pages/HomePage/components/BacklogTable/utils/util";
import axiosInstance from "../../http-common";
import getErrorMessage from "../../util";
import { BACKLOG_LOAD_FAILURE, BACKLOG_LOAD_START, BACKLOG_LOAD_SUCCESS, BACKLOG_EDIT_COMPLETION_DATE_SUCCESS, BACKLOG_EDIT_COMPLETION_DATE_FAILURE, BACKLOG_GENERAL_EDIT_SUCCESS, BACKLOG_SAMPLE_STATUS_FILTER_CHANGE, BACKLOG_SAMPLE_STATUS_FILTER_START, BACKLOG_SAMPLE_STATUS_FILTER_COMPLETE, BACKLOG_EDIT_APPROVAL_STATUS_SUCCESS, BACKLOG_EDIT_APPROVAL_STATUS_FAILURE } from "./backlog.types";
import { PO_Backlog_Service } from "./po_backlog.services";
import { perform_analysis_on_backlog_data } from "./utils/analyze";
import { test_status_column_properties } from "../../Pages/HomePage/components/BacklogTable/utils/backlog_datagrid_common_column_properties";
// import { calculate_age, convert_excel_serial_number_to_date, find_target_date } from "./utils/backlog_utils";
// import { v4 } from "uuid";

// const backend_url = process.env.REACT_APP_BACKEND_MAIN_URL;

const backlog_load_start_action = () => ({
  type: BACKLOG_LOAD_START
});

const backlog_load_success_action = (payload) => ({
  type: BACKLOG_LOAD_SUCCESS,
  payload
});

const backlog_load_failure_action = (payload) => ({
  type: BACKLOG_LOAD_FAILURE,
  payload
});

export const load_intm_backlog_from_backend = (state) => async (dispatch) => {
  console.log("loading backlog from backend");
  // dispatch(intm_backlog_load_start_action());
  try {
    const response_sample_types = await PO_Backlog_Service.sample_types_get();
    const result_sample_types = response_sample_types.data;
    if (result_sample_types.data && Array.isArray(result_sample_types.data)) {
      // console.log(response_sample_types.data);
      const sample_types = result_sample_types.data;
      const payload = {
        sample_types
      };
      const headers = Object.keys(backlog_table_headers);
      const additional_headers = await axiosInstance.get(`v1/qc/get_tests?type=backlog`);
      const columns = headers.filter(header => header !== "id").map(header => ({
        field: header.trim().toLowerCase().split(" ").join("_").split("\n").join("_"),
        width: 200,
        ...backlog_table_headers[header],
      })).concat(...additional_headers.data?.tests.map(test => ({
        field: test,
        width: 200,
        headerName: test,
        renderCell: render_status_cell,
        ...test_status_column_properties
      })) || []);
      for (let sample_type of sample_types) {
        const response = await PO_Backlog_Service.backlog_data_get(sample_type);
        const result = response.data;
        if (result.data && result.status === "success") {
          const table_data = result.data.map(item => ({ ...item, id: item._id }));
          // console.log({ table: table_data || [], result: result.data, sample_type });
          const insights = perform_analysis_on_backlog_data(table_data);
          payload[sample_type] = {
            insights,
            columns,
            table_data: table_data || [],
            status: true
          };
        }
      }
      setTimeout(() => {
        dispatch(backlog_load_success_action(payload));
        // dispatch(po_load_success_action(payload));
      }, 1500);
    }
    else if (result_sample_types.data && typeof result_sample_types.data === "object") {
      const major_categories = Object.keys(result_sample_types.data);
      const payload = {
        sample_types: major_categories
      };
      const headers = Object.keys(backlog_table_headers);
      const additional_headers = await axiosInstance.get(`v1/qc/get_tests?type=backlog`);
      const columns = headers.filter(header => header !== "id").map(header => ({
        field: header.trim().toLowerCase().split(" ").join("_").split("\n").join("_"),
        width: 200,
        ...backlog_table_headers[header],
      })).concat(...additional_headers.data?.tests.map(test => ({
        field: test,
        width: 200,
        headerName: test,
        renderCell: render_status_cell,
        ...test_status_column_properties
      })) || []);
      for (let sample_type of major_categories) {
        const response = await PO_Backlog_Service.backlog_data_get(sample_type);
        const result = response.data;
        if (result.data && result.status === "success") {
          const table_data = result.data.map(item => ({ ...item, id: item._id }));
          // console.log({ table: table_data || [], result: result.data, sample_type });
          const insights = perform_analysis_on_backlog_data(table_data);
          payload[sample_type] = {
            insights,
            columns,
            table_data: table_data || [],
            status: true
          };
        }
      }
      setTimeout(() => {
        dispatch(backlog_load_success_action(payload));
        // dispatch(po_load_success_action(payload));
      }, 1500);
    }
  } catch (error) {
    const err = getErrorMessage(error);
    console.log("error", err);
    // TODO: Add a dispatcher here.
    // dispatch(po_load_failure_action(err));
  }
};

export const handle_intm_backlog_upload = (file) => (dispatch) => {
  dispatch(backlog_load_start_action());
  try {
    // console.log({ table_data });
    const payload = {
      file: file,
      status: true,
    };
    dispatch(backlog_load_success_action(payload));
  } catch (error) {
    const err = getErrorMessage(error);
    console.log({ err });
    dispatch(backlog_load_failure_action(err));
  }
};

const backlog_edit_completion_date_success_action = (payload) => ({
  type: BACKLOG_EDIT_COMPLETION_DATE_SUCCESS,
  payload
});

const backlog_edit_completion_date_failure_action = (payload) => ({
  type: BACKLOG_EDIT_COMPLETION_DATE_FAILURE,
  payload
});

export const handle_backlog_completion_date_update = (state, e, excel_row, id) => (dispatch) => {
  dispatch(backlog_load_start_action());
  try {
    const due_date = convert_dd_mm_yy_to_milliseconds(excel_row["due_date"]);
    const days = (new Date(e.$d).getTime() - due_date) / (1000 * 60 * 60 * 24);
    console.log(days, id);
    const temp = { ...state };
    const temp_arr = JSON.parse(JSON.stringify(temp.backlog.intm.table_data)).map(data => {
      if (data.id === id) {
        console.log("updating", data);
        data["completion_date"] = convert_date_to_dd_mm_yyyy(new Date(e.$d));
        data["completed_within__(in_days)"] = days;
        data["remarks"] = "Completed";
      }
      return { ...data };
    });
    const insights = perform_analysis_on_backlog_data(temp_arr);
    temp.backlog.intm.table_data = temp_arr;
    const payload = {
      ...temp.backlog.intm,
      insights
    };
    dispatch(backlog_edit_completion_date_success_action(payload));
  } catch (error) {
    const error_message = getErrorMessage(error);
    dispatch(backlog_edit_completion_date_failure_action(error_message));
  }
  // set_backlog_object((prev) => {
  //   const temp = { ...prev };
  //   return temp;
  // });
};

// const backlog_edit_remarks_success_action = (payload) => ({
//   type: BACKLOG_INTM_EDIT_REMARK_SUCCESS,
//   payload
// });

// const backlog_edit_remarks_failure_action = (payload) => ({
//   type: BACKLOG_INTM_EDIT_REMARK_FAILURE,
//   payload
// });

export const handle_backlog_AR_Number_Update = (state, value, excel_row, id, key_name) => async (dispatch) => {
  // console.log({ state, value, excel_row, id, key_name });
  // const temp = { ...state };
  const batch_no = excel_row.batch_number;
  // const remark = excel_row.remark;
  const material_type = excel_row?.["Material Type"];
  var formdata = new FormData();
  formdata.append("batch_number", batch_no);
  formdata.append("value", value);
  formdata.append("field_to_update", key_name);
  formdata.append("material_type", material_type);
  // formdata.append("reviewers_remark", value);

  // var requestOptions = {
  //   method: 'PATCH',
  //   body: formdata,
  //   redirect: 'follow'
  // };

  axiosInstance.patch(`/v1/qc/backlog_po/`, formdata)
    .then(response => response.json())
    .then(result => {
      const { status } = result;
      if (status && status === "success") {
        dispatch(load_intm_backlog_from_backend());
        console.log("done!");
      }
      console.log(result);
    })
    .catch(error => console.log('error', error));
};
export const handle_backlog_status_remarks_update = (state, e, excel_row, id, key_name) => async (dispatch) => {
  const { target: { value } } = e;
  console.log({ state, value, excel_row, id, key_name });
  // const temp = { ...state };
  const batch_no = excel_row.batch_number;
  // const remark = excel_row.remark;
  const material_type = excel_row?.["Material Type"];
  var formdata = new FormData();
  formdata.append("batch_number", batch_no);
  formdata.append("value", value);
  formdata.append("field_to_update", key_name);
  formdata.append("material_type", material_type);
  // formdata.append("reviewers_remark", value);

  // var requestOptions = {
  //   method: 'PATCH',
  //   body: formdata,
  //   redirect: 'follow'
  // };

  axiosInstance.patch(`/v1/qc/backlog_po/`, formdata)
    .then(response => response.json())
    .then(result => {
      const { status } = result;
      if (status && status === "success") {
        dispatch(load_intm_backlog_from_backend());
        console.log("done!");
      }
      console.log(result);
    })
    .catch(error => console.log('error', error));
};
export const handle_backlog_reviewer_remarks_update = (state, e, excel_row, id, key_name) => async (dispatch) => {
  const { target: { value } } = e;
  console.log({ state, value, excel_row, id, key_name });
  // const temp = { ...state };
  const batch_no = excel_row.batch_number;
  const remark = excel_row.remark;
  const material_type = excel_row?.["Material Type"];
  var formdata = new FormData();
  formdata.append("batch_no", batch_no);
  formdata.append("remark", remark);
  formdata.append("reviewers_remark", value);
  formdata.append("material_type", material_type);

  // var requestOptions = {
  //   method: 'POST',
  //   body: formdata,
  //   redirect: 'follow'
  // };

  axiosInstance.post(`/v1/qc/update_backlog_status/`, formdata)
    .then(response => response.data)
    .then(result => {
      const { status } = result;
      if (status && status === "success") {
        dispatch(load_intm_backlog_from_backend());
        console.log("done!");
      }
      console.log(result);
    })
    .catch(error => console.log('error', error));
};
export const handle_backlog_stage_status_update = (state, e, excel_row, id, key_name) => async (dispatch) => {
  const { target: { value } } = e;
  console.log({ state, value, excel_row, id, key_name });
  // const temp = { ...state };
  const batch_no = excel_row.batch_number;
  const remark = value;
  const material_type = excel_row?.["Material Type"];
  var formdata = new FormData();
  formdata.append("batch_no", batch_no);
  formdata.append("remark", remark);
  formdata.append("material_type", material_type);

  // var requestOptions = {
  //   method: 'POST',
  //   body: formdata,
  //   redirect: 'follow'
  // };

  axiosInstance.post(`/v1/qc/update_backlog_status/`, formdata)
    .then(response => response.data)
    .then(result => {
      const { status } = result;
      if (status && status === "success") {
        dispatch(load_intm_backlog_from_backend());
        console.log("done!");
      }
      console.log(result);
    })
    .catch(error => console.log('error', error));
};

const backlog_general_edit_success_action = (payload) => ({
  type: BACKLOG_GENERAL_EDIT_SUCCESS,
  payload
});

// const backlog_general_edit_failure_action = (payload) => ({
//   type: BACKLOG_INTM_GENERAL_EDIT_FAILURE,
//   payload
// });

export const handle_backlog_general_data_update = (e, state, excel_row, id, key_name, value) => (dispatch) => {
  dispatch(backlog_load_start_action());
  const temp = { ...state };
  const temp_arr = JSON.parse(JSON.stringify(temp.backlog.intm.table_data)).map(data => {
    if (data.id === id) {
      console.log("updating", data);
      data[key_name] = value;
    }
    return { ...data };
  });
  const insights = perform_analysis_on_backlog_data(temp_arr);
  temp.backlog.intm.table_data = temp_arr;
  const payload = {
    ...temp.backlog.intm,
    insights
  };
  dispatch(backlog_general_edit_success_action(payload));
};

const sample_status_filter_start_action = () => ({
  type: BACKLOG_SAMPLE_STATUS_FILTER_START,
});

const sample_status_filter_change_action = (payload) => ({
  type: BACKLOG_SAMPLE_STATUS_FILTER_CHANGE,
  payload
});

const sample_status_filter_complete_action = () => ({
  type: BACKLOG_SAMPLE_STATUS_FILTER_COMPLETE,
});

export const handle_sample_status_filter_change = (selected_filter, state) => (dispatch) => {
  dispatch(sample_status_filter_start_action());
  const temp = { ...state };
  const temp_arr = JSON.parse(JSON.stringify(temp.backlog.intm.table_data));
  const insights = perform_analysis_on_backlog_data(temp_arr, selected_filter);
  const payload = {
    ...temp.backlog.intm,
    insights
  };
  dispatch(sample_status_filter_change_action(payload));
  setTimeout(() => {
    dispatch(sample_status_filter_complete_action());
  }, 2500);
};


const backlog_edit_approval_status_success_action = (payload) => ({
  type: BACKLOG_EDIT_APPROVAL_STATUS_SUCCESS,
  payload
});

const backlog_edit_approval_status_failure_action = (payload) => ({
  type: BACKLOG_EDIT_APPROVAL_STATUS_FAILURE,
  payload
});

export const handle_backlog_approval_status_update = (state, e, excel_row, id, key_name) => (dispatch) => {
  const { target: { value } } = e;
  console.log({ state, value, excel_row, id, key_name });
  const temp = { ...state };
  try {
    const temp_arr = JSON.parse(JSON.stringify(temp.backlog.intm.table_data)).map(data => {
      if (data.id === id) {
        console.log("updating", data);
        data[key_name] = value;
        if (value === "approved") {
          data["approval_date"] = convert_date_to_dd_mm_yyyy(new Date());
          // console.log({ data });
        }
      }
      return { ...data };
    });
    const insights = perform_analysis_on_backlog_data(temp_arr);
    temp.backlog.intm.table_data = temp_arr;
    const payload = {
      ...temp.backlog.intm,
      insights
    };
    dispatch(backlog_edit_approval_status_success_action(payload));
  } catch (error) {
    const message = getErrorMessage(error);
    dispatch(backlog_edit_approval_status_failure_action(message));
  }

};